document.addEventListener("DOMContentLoaded", function() {
  var lightbox = document.getElementById("lightbox");
  var btn = document.getElementById("viewDetailsBtn");
  var span = document.getElementsByClassName("close")[0];
  
  btn.onclick = function() {
    lightbox.style.display = "block";
  }
  
  span.onclick = function() {
    lightbox.style.display = "none";
  }
  
  window.onclick = function(event) {
    if (event.target == lightbox) {
      lightbox.style.display = "none";
    }
  }
});
